export default {
  ['loadStart'](state, payload) {
    if (!state.loading.includes(payload)) {
      state.loading.push(payload);
    }
  },
  ['loadFinish'](state, payload) {
    if (state.loading.includes(payload)) {
      state.loading = state.loading.filter(obj => obj !== payload);
    }
  },
};
